exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.header-statement[data-v-94ccdfa8]{\n  padding: 15px 20px;\n.text-sm{\n    text-transform: initial !important;\n    display: block;\n}\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build/frontend/common-v2/components/mdm-v2/Form.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;AACrB;IACI,mCAAmC;IACnC,eAAe;CAClB;CACA","file":"Form.vue","sourcesContent":["\n.header-statement[data-v-94ccdfa8]{\n  padding: 15px 20px;\n.text-sm{\n    text-transform: initial !important;\n    display: block;\n}\n}\n"],"sourceRoot":""}]);

// exports
